/**
 * Transforms a Cloudinary URL to include auto-format, auto-quality and width optimizations.
 * Falls back to the original URL if it's not a Cloudinary URL (e.g., placeholder).
 *
 * @param {string} url   - Original image URL
 * @param {number} width - Desired render width in CSS pixels (function doubles for 2× retina)
 * @returns {string}
 */
export function cloudinaryUrl(url, width = 800) {
  if (!url || !url.includes('res.cloudinary.com')) return url;
  // Avoid double-inserting transformations
  if (url.includes('/f_auto') || url.includes('/q_auto')) return url;
  return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
}
